const key = "sidebarWidth";

export const SIDEBAR_MIN_WIDTH = 228;
export const SIDEBAR_MAX_WIDTH = 320;
export const SIDEBAR_DEFAULT_WIDTH = 260;

export const clampSidebarWidth = (width: number) =>
  Math.round(Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, width)));

export const readSidebarWidth = () =>
  clampSidebarWidth(Number(localStorage.getItem(key)) || SIDEBAR_DEFAULT_WIDTH);

export const writeSidebarWidth = (width: number) =>
  localStorage.setItem(key, String(width));
